import * as React from "react"

const SvgMoney = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 15.428a2.9 2.9 0 0 0 2.125-.875A2.9 2.9 0 0 0 15 12.428q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 9.43q-1.25 0-2.125.874A2.9 2.9 0 0 0 9 12.428q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875" />
    <path
      fillRule="evenodd"
      d="M4 19.428q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 17.428v-10q0-.824.587-1.412A1.93 1.93 0 0 1 4 5.429h16q.824 0 1.413.587.587.588.587 1.413v10q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587zm13-2q0-1.237.881-2.118A2.9 2.9 0 0 1 20 14.428v-4a2.9 2.9 0 0 1-2.119-.88A2.9 2.9 0 0 1 17 7.427H7q0 1.239-.881 2.12a2.9 2.9 0 0 1-2.119.88v4q1.237 0 2.119.882.88.88.881 2.118h10Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMoney
